export default __webpack_public_path__ + "static/media/circle.35f878c2.png";